import { CQ_ACTION_CHARACTERISTICS_ID } from '../../catalogConstants';

export const searchClientActionCqsiId = (actionId, phoneNumber, options) => {
  if (Array.isArray(options)) {
    let option = options.find((opt) => {
      return (
        opt.actionId === actionId
        && opt.clientPhoneNumberToBeAppliedTo === phoneNumber
      );
    });
    if (option) {
      const { cqsiId, id, productType } = option;
      return { cqsiId, id, productType };
    }
    option = options.find((opt) => {
      return opt.actionId === actionId;
    });
    if (option) {
      const { cqsiId, id, productType } = option;
      return { cqsiId, id, productType };
    }
  }

  return null;
};

export const searchSecondaryClientActionCqsiId = (actionId, phoneNumber, optionsGroups, groupId) => {
  const optionsGroup = optionsGroups.find(group => group.id === groupId);

  if (optionsGroup) {
    const optionInfo = searchClientActionCqsiId(actionId, phoneNumber, optionsGroup.customerQuoteItems);

    if (optionInfo && optionInfo.cqsiId) {
      return optionInfo.cqsiId;
    }
  }

  return null;
};

export const getPortaActionCharacteristics = (components, portabilityInfo) => {
  const actionCharacteristicsResolved = [];
  if (Array.isArray(components) && components.length > 0) {
    components.forEach((component) => {
      const { customerQuotePossibleActions } = component;
      if (
        Array.isArray(customerQuotePossibleActions)
        && customerQuotePossibleActions.length > 0
      ) {
        customerQuotePossibleActions.forEach((possibleAction) => {
          const {
            id, actionCharacteristics, productOffering,
          } = possibleAction;
          let {
            clientPhoneNumberToBeAppliedTo,
          } = possibleAction;
          let actionResolved = null;
          if (
            Array.isArray(actionCharacteristics)
            && actionCharacteristics.length > 0
          ) {
            const iccAction = actionCharacteristics.find(
              (actionCharacteristic) => {
                return (
                  actionCharacteristic.id === CQ_ACTION_CHARACTERISTICS_ID.ICC
                );
              },
            );
            if (iccAction) {
              // TODO ÑAPA PORTABILIDADES MIENTRAS NO LO ARREGLE TCOL
              if (!clientPhoneNumberToBeAppliedTo && Object.keys(portabilityInfo) && Object.keys(portabilityInfo)[0]) {
                ([clientPhoneNumberToBeAppliedTo] = Object.keys(portabilityInfo));
              }
              actionResolved = {
                id,
                clientPhoneNumberToBeAppliedTo,
                actionCharacteristics: portabilityInfo[clientPhoneNumberToBeAppliedTo] ? [
                  {
                    ...iccAction,
                    value: portabilityInfo[clientPhoneNumberToBeAppliedTo],
                  },
                ] : [],
              };
            }
          }

          if (!actionResolved && productOffering && productOffering.ppipAvailable) {
            actionResolved = {
              id,
              clientPhoneNumberToBeAppliedTo,
            };
          }
          if (actionResolved) {
            actionCharacteristicsResolved.push(actionResolved);
          }
        });
      }
    });
  }
  return actionCharacteristicsResolved;
};
